import React from 'react'
import { useTranslation } from 'react-i18next';
import { Tag } from 'antd';

const MultipleFacesButton = ({mirror_screens_count}) => {
  const { t } = useTranslation();

  return (
    <Tag color="orange" size="small">
        <span style={{fontSize: "small"}}>
            {mirror_screens_count}{" "}
            {mirror_screens_count > 1 ? t("faces") : t("face")}
        </span>
    </Tag>
  )
}

export default MultipleFacesButton